import { MGPOptional, Encoder, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { PentagoState } from './PentagoState';
export class PentagoMove extends MoveCoord {
    blockTurned;
    turnedClockwise;
    static encoder = Encoder.tuple([Coord.encoder, MGPOptional.getEncoder(Encoder.identity()), Encoder.identity()], (move) => [move.coord, move.blockTurned, move.turnedClockwise], (fields) => PentagoMove.of(fields[0], fields[1], fields[2]));
    static of(coord, blockTurned, turnedClockwise) {
        return new PentagoMove(coord.x, coord.y, blockTurned, turnedClockwise);
    }
    static withRotation(x, y, blockTurned, turnedClockwise) {
        Utils.assert(0 <= blockTurned && blockTurned <= 3, 'This block does not exist: ' + blockTurned);
        return new PentagoMove(x, y, MGPOptional.of(blockTurned), turnedClockwise);
    }
    static rotationless(x, y) {
        return new PentagoMove(x, y, MGPOptional.empty());
    }
    constructor(x, y, blockTurned, turnedClockwise = false) {
        super(x, y);
        this.blockTurned = blockTurned;
        this.turnedClockwise = turnedClockwise;
        Utils.assert(PentagoState.isOnBoard(this.coord), 'The board is a ' + PentagoState.SIZE + ' space wide square, invalid coord: ' + this.coord.toString());
    }
    toString() {
        if (this.blockTurned.isPresent()) {
            return 'PentagoMove(' + this.coord.toString() + ', ' + this.blockTurned.get() + ', ' +
                (this.turnedClockwise ? 'CLOCKWISE' : 'ANTI-CLOCKWISE') + ')';
        }
        else {
            return 'PentagoMove' + this.coord.toString();
        }
    }
    equals(other) {
        if (this.coord.equals(other.coord) === false)
            return false;
        if (this.blockTurned.equals(other.blockTurned) === false)
            return false;
        return this.turnedClockwise === other.turnedClockwise;
    }
}
